import { useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { TenantProfile } from '@klareospace/pharos-lib-types';
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { createTenantProfileApi, tenantProfileKeys } from '../api';

export function useTenantProfile(): UseQueryResult<TenantProfile> {
  const client = useApiClient('admin-auth');
  const api = createTenantProfileApi(client);

  return useQuery({
    queryFn: () => api.getTenantProfile(),
    queryKey: tenantProfileKeys.me(),
    staleTime: 30 * 60_000,
  });
}
